import { LocalizationApi, useAPIQueryAndQueryKey } from "melco-shared-logic";
import { PRODUCT_CODE } from "../../helper/localestringHelper";

export const useGetLocaleStringById = (
  localeStringId: string,
  moduleCode: string
) => {
  //  const token = useUserToken();

  //const baseApiConfig = useBaseAPIConfig();

  const query = useAPIQueryAndQueryKey(
    LocalizationApi,
    ["getLocaleStringById", localeStringId],
    async (api) => {
      //const api = new ControlCenterApi(baseApiConfig({ token }));
      let response;
      response = await api.localizationGet({
        moduleCode: PRODUCT_CODE ?? null,
        id: localeStringId ?? null,
      });

      return response ? response : null;
    }
  );

  return query;
};
